import { motion } from "framer-motion";
import { Cloud, SectionTitle, Reveal } from "./Decor";
import { ICONS } from "./icons";

const tones = [
  "bg-sky-100 text-sky-700", "bg-pink-100 text-pink-600", "bg-yellow-100 text-orange-600",
  "bg-purple-100 text-purple-600", "bg-green-100 text-green-700",
];

export const ServicesSection = ({ c, s }) => {
  const items = (c?.services?.items || []).filter((x) => x.title);
  return (
    <section id="services" className="relative overflow-hidden bg-sky-50 py-16 sm:py-20" data-testid="services-section">
      <Cloud className="drift absolute -right-12 top-10 w-44 text-white" />
      <div className="relative mx-auto max-w-6xl px-4 sm:px-6">
        <SectionTitle id="services" title={s.title} subtitle={s.subtitle} />
        {c?.services?.intro && (
          <Reveal as="p" className="-mt-6 mb-8 max-w-2xl text-base text-slate-600"><span data-testid="services-intro">{c.services.intro}</span></Reveal>
        )}
        <div className="grid grid-cols-1 gap-4 min-[420px]:grid-cols-2 md:grid-cols-3">
          {items.map((it, i) => {
            const Icon = ICONS[it.icon] || ICONS.stethoscope;
            return (
              <motion.div
                key={it.id || i}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ y: -4 }}
                className="group rounded-[1.75rem] bg-white p-5 shadow-sm ring-1 ring-sky-100 transition-shadow duration-300 hover:shadow-lg"
              >
                <span className={`inline-flex h-12 w-12 items-center justify-center rounded-2xl transition-transform duration-300 group-hover:rotate-[-8deg] group-hover:scale-110 ${tones[i % 5]}`}>
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="font-display mt-3 text-lg font-semibold leading-snug text-blue-900">{it.title}</h3>
                {it.description && <p className="mt-1 text-sm leading-relaxed text-slate-600">{it.description}</p>}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
